module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAADCAYAAABWKLW/AAAAHklEQVQImWOUEFH9f2aSL8OVk/cYmBiQAILDwMAAAK6QBXxXGgHEAAAAAElFTkSuQmCC"